'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Controller(BusComponent, $filter, $state, $window, PageHeading, Waybill, $stateParams, toastr) {
	'ngInject';

	var vm = this;
	var emptyRows = 5;
	vm.nonPrintableRows = [];
	vm.waybill = JSON.parse(JSON.stringify(Waybill));
	vm.print = print;
	vm.selectSeat = selectSeat;
	vm.choice = 'waybill';
	vm.seats = [];
	// Total bus seats count
	vm.seatsCount = $stateParams.seats;
	vm.printableColumns = {
		'number': 1,
		'seat': 1,
		'ticket': 1,
		'names': 1,
		'phone': 1,
		'subLine': 1,
		'price': 1,
		'note': 1,
		'soldFrom': 1
	};
	vm.stateParams = $stateParams;
	vm.unavailablePassanger = unavailablePassanger;
	vm.nonPrintableRow = '';
	vm.updateWaibill = updateWaybill;

	if (Waybill.waybill && Object.keys(Waybill.waybill).length !== 0) {
		vm.waybillInfo = {
			'registration_number': Waybill.waybill.hasOwnProperty('id') ? Waybill.waybill.registration_number : '',
			'first_driver': Waybill.waybill.hasOwnProperty('id') ? Waybill.waybill.first_driver : '',
			'second_driver': Waybill.waybill.hasOwnProperty('id') ? Waybill.waybill.second_driver : '',
			'third_driver': Waybill.waybill.hasOwnProperty('id') ? Waybill.waybill.third_driver : '',
			'travel_date': $stateParams.date
		};
	} else {
		vm.waybillInfo = {
			'travel_date': $stateParams.date
		};
	}

	activate();

	function activate() {
		var heading = $filter('translate')('SIDEBAR.WAYBILL');
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.WAYBILL');

		addEmptyRows();
		PageHeading.setPageHeading(heading, title);
	}

	function print() {
		$window.print();
	}

	function selectSeat(seat) {
		if ((seat.status === 'paid' || seat.status === 'reserved') && $window.confirm($filter('translate')('CONFIRM.EDIT_SEAT'))) {
			$state.go('app.private.tickets.edit', { 'seatId': seat.id });
		}
	}

	function addEmptyRows() {
		for (var i = 0; i < emptyRows; i++) {
			vm.waybill.seats.push(i);
		}
		return vm.waybill.seats;
	}

	/** Remove clients from waybill or add it
  * @params { Number } - item
  */
	function unavailablePassanger(passanger) {
		var availableItem = vm.nonPrintableRows.indexOf(passanger.toString());

		if (availableItem !== -1) {
			vm.nonPrintableRows[passanger] = false;
		} else {
			vm.nonPrintableRows.push(vm.nonPrintableRow[passanger]);
			vm.nonPrintableRows[passanger] = passanger.toString();
		}
	}

	/** */
	function updateWaybill(params) {
		if (vm.waybillForm.$invalid) {
			toastr.error($filter('translate')('ERRORS.GENERAL'));
			return false;
		}

		BusComponent.updateWaybill(Waybill.id, params).then(function (data) {
			if (!data.data.errors) {
				toastr.success('Waybill changes has been changed');
			} else {
				toastr.success(data.data.errors.error[0]);
			}
		});
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/waybill/show/show.controller.js
 **/